import { useCompaniesStore } from "@/components/Companies/CompaniesStore"
import { useCompanyDriversStore } from "@/components/Companies/companyDriversStore"
import { useEmployeesStore } from "@/components/Employees/EmployeesStore"
import { useVatsStore } from "@/components/Finance/Taxes/VatsStore"
import { useJobsStore } from "@/components/Jobs/JobsStore"
import { useTradeJobsStore } from "@/components/Jobs/TradeJobView/TradeJobsStore"
import { useYardJobsStore } from "@/components/Jobs/YardJobView/YardJobsStore"
import { useCompanyVehiclesStore } from "@/components/Vehicles/CompanyVehiclesStore"
import { useVehicleAssignmentsStore } from "@/components/Vehicles/VehicleAssignmentsStore"
import { useVehiclesStore } from "@/components/Vehicles/VehiclesStore"
import reportError from "@/utils/reportError"

let lastInitializedTenantId = null

export const storesInitializer = (tenantCompany, webSocket) => {
  const tenantId = tenantCompany?.id
  if (!tenantId) {
    reportError(new Error("Tenant company is required"), { context: "storesInitializer" })
    console.error("Tenant company is required but not provided.")
    return
  }

  const tenantChanged = lastInitializedTenantId && lastInitializedTenantId !== tenantId
  if (tenantChanged) {
    console.info(`Reinitializing stores for tenant switch: ${lastInitializedTenantId} -> ${tenantId}`)
  }

  useCompaniesStore().initialize(tenantCompany, webSocket)
  useCompanyDriversStore().initialize(tenantCompany, webSocket)
  useCompanyVehiclesStore().initialize(tenantCompany, webSocket)
  useVehiclesStore().initialize(tenantCompany)
  useEmployeesStore().initialize(tenantCompany, webSocket)
  useVatsStore().initialize(tenantCompany)
  useJobsStore().initialize(tenantCompany, webSocket)
  useYardJobsStore().initialize(tenantCompany, webSocket)
  useTradeJobsStore().initialize(tenantCompany, webSocket)
  useVehicleAssignmentsStore().initialize(tenantCompany, webSocket)

  lastInitializedTenantId = tenantId
}
